import { en } from './locales/en';
import { ar } from './locales/ar';

export const TRANSLATIONS = {
  en,
  ar,
};
